export default function ({ $gtm, route }) {
  /**
   * we are not initializing Google Tag Manager on the password reset page.
   * it can leak the reset token.
   */
  if (route && !route?.path.includes("reset")) {
    $gtm.init(process.env.GOOGLE_TAG_MANAGER_ID);
  }
}
